import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import './css/Start.css';
import Footer from "./components/Footer";
import HomeOffline from "./HomeOffline";
import Register from "./components/Register";
import Activate from "./components/Activate";
import Login from "./components/Login";
import OrderContract from "./components/OrderContract";
import Tariffing from "./components/Tariffing";
import OrderSuccess from "./components/OrderSuccess";
import ResetPasswordSuccess from "./components/ResetPasswordSuccess";
import ActivateSuccess from "./components/ActivateSuccess";
import OfflineMenu from "./OfflineMenu";
import RegisterSuccess from "./components/RegisterSuccess";
import RegisterQuestion from "./components/RegisterQuestion";
import RegisterExistingCustomer from "./components/RegisterExistingCustomer";
import OrderPopUp from "./components/OrderPopUp";
import NoPaymentOffline from "./components/NoPaymentOffline";
import ErrorOffline from "./components/ErrorOffline";
import ErrorLogin from "./components/ErrorLogin";
import ResetPassword from './components/ResetPassword';
import TermsOfUsage from "./components/TermsOfUsage";
import RegisterFKV from "./components/RegisterFKV";
import LogoutSuccess from "./components/LogoutSuccess";
import ActivateEMail from "./components/ActivateEMail";
import ActivateEMailSuccessOffline from "./components/ActivateEMailSuccessOffline";
import VerificationReupload from './components/VerificationReupload';

// eslint-disable-next-line react/prefer-stateless-function
class Start  extends Component
 {
    render()
    {
        return (
          <div>
            <OfflineMenu />
            {/*<div style={{ margin: '60px',textAlign:'center' }}></div>*/}
            <div id={"OfflinePage"} style={{ margin: '60px',textAlign:'center' ,marginTop: "150px" }}>
              <Switch>
                <Route
                  path='/home'
                  component={HomeOffline} />
                <Route
                  path='/orderSuccess'
                  component={OrderSuccess} /> 
                <Route
                  path='/order'
                  component={OrderContract} />
                <Route
                  path='/login'
                  component={Login} />
                <Route
                  path='/registerSuccess'
                  component={RegisterSuccess} />
                <Route
                  path='/register'
                  component={Register} />
                <Route
                  path='/registerQuestion'
                  component={RegisterQuestion} />
                <Route
                  path='/registerExistingCustomer'
                  component={RegisterExistingCustomer} />
                <Route
                  path='/activate/:id'
                  component={Activate} />
                <Route
                  path='/tariffing'
                  component={Tariffing} />
                <Route
                  path='/resetPassword'
                  component={ResetPassword} />
                <Route
                  path='/resetPasswordSuccess'
                  component={ResetPasswordSuccess} />
                <Route
                  path='/activateSuccess'
                  component={ActivateSuccess} />
                <Route
                  path='/orderNewCustomer'
                  component={OrderPopUp} />
                <Route
                  path='/noPaymentOffline'
                  component={NoPaymentOffline} />
                <Route
                  path='/termsofusage'
                  component={TermsOfUsage} />
                <Route
                  path='/errorOffline'
                  component={ErrorOffline} />
                <Route
                  path='/error'
                  component={ErrorLogin} />
                <Route
                  path='/registerFKV'
                  component={RegisterFKV} />
                <Route                    
                  path='/logoutSuccess'
                  component={LogoutSuccess} />
                <Route 
                  path='/changeMail/:id' 
                  component={ActivateEMail} />
                <Route 
                  path='/activateEMailSuccessOffline' 
                  component={ActivateEMailSuccessOffline} />
                <Route
                  path='/verificationReupload'
                  component={VerificationReupload} />
                <Route
                  path='/'
                  component={HomeOffline} />
              </Switch>
            </div>
            <Footer />
          </div>
        );
    }
}
export default Start;
